export enum InlineActions {
  Create,
  Retrieve,
  Update,
  Delete,
}
